import React from 'react'
import _ from 'lodash'
import SolutionBox from '../../components/SolutionBox'
import SourceBox from '../../components/SourceBox'
import StudentQualityList from '../../components/StudentQualityList'
import '../../assets/css/pages/track_progress/research-submissions.css'

const ResearchSubmissions = props => {
  const { description, articles } = props

  return(
    <div className='research-submissions'>
      <p className='task'>
        <span>TASK: </span>
        <span>{description}</span>
      </p>
      {_.map(articles, article =>
        <div className='article-wrapper'>
          <SourceBox author={article.author} title={article.title} text={article.text}/>
          <div className='answer-wrapper'>
            {_.map(article.answers, answer =>
              <div className='answer-column'>
                <SolutionBox {...answer}/>
                <StudentQualityList students={answer.students}/>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default ResearchSubmissions
